/*eslint-disable*/
import React from "react";
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

// material ui icons
import MailOutline from "@material-ui/icons/Business";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import MyForm from "components/Form";
// import { YEAR, COMPANY_TYPE } from "../../../_constants/form.constants";
import Button from "@material-ui/core/Button";

// style for this view
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";

import { connect } from "react-redux";
import { crudActions, loaderActions } from "../../../_actions";
import { crudService } from "../../../_services";

import SimpleReactValidator from "simple-react-validator";
import Icon from "@material-ui/core/Icon";

const initialState = {
  id: "new",
  form: {
    name: "",
    description: "",
    component: "",
    outcome: "",
    max_price: "",
    min_price: "",
    seo_url_slug: "",
    meta_description: "",
    meta_title: "",
    category_id: "",
    industries: [],
    personals: [],
    consultants: [],
  },
};
class ConsultantForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = initialState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
  }

  handleInputChange(event) {
    const newState = Object.assign({}, this.state);
    if (event.target.type == "checkbox") {
      newState.form[event.target.name] = event.target.checked;
    } else {
      newState.form[event.target.name] = event.target.value;
    }
    this.setState(newState);
    this.handleError();
  }

  getFormFields = () => {
    const { form } = this.state;
    const formFields = [
      {
        name: "name",
        label: "Name",
        type: "textbox",
        value: form.name || "",
        icon: "assignment",
        error: this.validator.message("name", form.name, "required|min:3"),
      },
      {
        name: "category_id",
        label: "Choose Category",
        type: "autocomplete",
        url: "categories?not_categories=[1,5,8]",
        getOptionLabel: "name",
        getOptionValue: "id",
        value: form.category_id,
        option: { label: form.category, value: form.category_id },
        error: this.validator.message(
          "category_id",
          form.category_id,
          "required"
        ),
      },
      {
        name: "description",
        label: "Description",
        type: "textbox",
        value: form.description || "",
        icon: "assignment",
        // error: this.validator.message("email", form.email, "email"),
      },
      {
        name: "component",
        label: "Component",
        type: "textbox",
        value: form.component || "",
        icon: "assignment",
        // error: this.validator.message("email", form.email, "email"),
      },
      {
        name: "outcome",
        label: "Outcome",
        type: "textbox",
        value: form.outcome || "",
        icon: "assignment",
        // error: this.validator.message("mobile", form.mobile, "min:10|max:15"),
      },
      {
        name: "price",
        label: "Price",
        type: "textbox",
        value: form.price || "",
        icon: "assignment",
        error: this.validator.message("price", form.price, "required"),
      },
      {
        name: "seo_url_slug",
        label: "SEO Slug URL",
        type: "textbox",
        value: form.seo_url_slug || "",
        icon: "assignment",
        // error: this.validator.message("details", form.details, "min:3"),
      },
      {
        name: "meta_description",
        label: "Meta Description",
        type: "textbox",
        value: form.meta_description || "",
        // error: this.validator.message(
        //   "Linkedin URL",
        //   form.linkedin_url,
        //   "required|url"
        // ),
      },
      {
        name: "meta_title",
        label: "Meta Title",
        type: "textbox",
        value: form.meta_title || "",
      },
      {
        name: "industries",
        label: "Choose Industries",
        type: "multi_group_autocomplete",
        url: "app/industries",
        getOptionLabel: "name",
        getOptionValue: "id",
        value: form.industries,
        error: "",
      },
      {
        name: "personals",
        label: "Choose Personas",
        type: "multi_group_autocomplete",
        url: "personals",
        getOptionLabel: "name",
        getOptionValue: "id",
        value: form.personals,
        error: "",
      },
    ];
    return formFields;
  };

  getValue(val) {
    const { id } = this.props.match.params;
    if (id && id === "new") {
      return val;
    } else {
      if (null === val) {
        return "";
      } else {
        return val;
      }
    }
  }

  handleError() {
    this.validator.showMessages();
    this.forceUpdate();
  }

  goBack = () => {
    this.props.history.push(`/admin/service`);
  };

  handleSubmit(e) {
    e.preventDefault();
    if (this.validator.allValid()) {
      let data = {
        name: this.state.form.name,
        description: this.state.form.description,
        component: this.state.form.component,
        outcome: this.state.form.outcome,
        price: this.state.form.price,
        seo_url_slug: this.state.form.seo_url_slug,
        meta_description: this.state.form.meta_description,
        meta_title: this.state.form.meta_title,
        category_id: this.state.form.category_id,
        industries: JSON.stringify(this.state.form.industries),
        personals: JSON.stringify(this.state.form.personals),
      };
      const { id } = this.props.match.params;
      if (id && id === "new") {
        this.props.create("formData", "services", data);
        this.goBack();
      } else {
        this.props.update("formData", "services", id, data);
      }
    } else {
      this.handleError();
    }
  }

  bindData = () => {
    const { id } = this.props.match.params;
    if (id && id !== "new") {
      crudService._get("services", id).then((response) => {
        if (response.status === 200) {
          this.setState({
            form: response.data,
          });
        }
      });
    }
  };

  componentDidMount() {
    this.bindData();
  }

  render() {
    const { classes } = this.props;
    const { id } = this.props.match.params;
    let title = "Add New Service";
    let btnText = "Create";
    if (id && id !== "new") {
      title = "Edit Consultant Details";
      btnText = "Update";
    }

    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={8}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <MailOutline />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{title}</h4>
            </CardHeader>
            <CardBody>
              <MyForm
                handleInputChange={this.handleInputChange}
                formFields={this.getFormFields()}
                handleSubmit={this.handleSubmit}
                handleCancel={this.goBack}
                btnText={btnText}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

ConsultantForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const { form, confirm } = state;
  return {
    form,
    confirm,
  };
};

const actionCreators = {
  getAll: crudActions._getAll,
  getCrud: crudActions._get,
  getAllParam: crudActions._getAllWithParam,
  clearCrud: crudActions._clear,
  create: crudActions._create,
  update: crudActions._update,
  showLoader: loaderActions.show,
  hideLoader: loaderActions.hide,
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    actionCreators
  )(ConsultantForm)
);
